export default __webpack_public_path__ + "static/media/12.3927e32b.png";